import { type IIconsVector } from 'shared/ui'
import { ChatbotInstructionType } from 'entities/Chatbot'

export type IChatbotTemplate = {
  type: ChatbotInstructionType
  icon: IIconsVector
  name: string
  description: string
  isNew?: boolean
  isDisabled?: boolean
}

export const ChatbotTemplate = new Map<ChatbotInstructionType, IChatbotTemplate>([
  [
    ChatbotInstructionType.BookAppointment,
    {
      type: ChatbotInstructionType.BookAppointment,
      icon: 'calendar',
      name: 'Book Appointments',
      description: 'Schedule meetings effortlessly',
      isNew: true,
      isDisabled: true,
    },
  ],
  [
    ChatbotInstructionType.Custom,
    {
      type: ChatbotInstructionType.Custom,
      icon: 'settings',
      name: 'Custom',
      description: 'Create a custom AI Agent with your instructions',
    },
  ],
  [
    ChatbotInstructionType.FAQ,
    {
      type: ChatbotInstructionType.FAQ,
      icon: 'messageQuestion',
      name: 'FAQ / Information',
      description: 'Answer questions about your business or products',
    },
  ],
  [
    ChatbotInstructionType.LeadQualification,
    {
      type: ChatbotInstructionType.LeadQualification,
      icon: 'usersCheck',
      name: 'AI Data Collection',
      description: 'Gather essential information to qualify your leads',
    },
  ],
  [
    ChatbotInstructionType.Support,
    {
      type: ChatbotInstructionType.Support,
      icon: 'heart',
      name: 'Support',
      description: 'Handle customer questions and support requests',
    },
  ],
])

export const ChatbotTemplateList = [...ChatbotTemplate.values()]
